module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("ALL Publishers")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--info pull-right",
    attrs: {
      "to": "/admin/publisher/add"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  }), _vm._v("\n          Create Publisher\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Search")]), _vm._v(" "), _c('el-input', {
    staticClass: "col-lg-3",
    attrs: {
      "type": "text",
      "placeholder": "Search Any Publisher By Name"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterByEachInput($event)
      }
    },
    model: {
      value: (_vm.searchvalue),
      callback: function($$v) {
        _vm.searchvalue = $$v
      },
      expression: "searchvalue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body pub-list"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "height": "400",
      "data": _vm.publisher
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "name",
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "domain-name"
        }, [_vm._v(_vm._s(("" + (props.row.name))))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Reports",
      "prop": "Reports",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Reports",
            "placement": "bottom"
          }
        }, [_c('router-link', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          attrs: {
            "to": ("" + ('/admin/publisher/'+props.row.id+'/ReportsRevenue/alldomain'))
          }
        }, [_c('i', {
          staticClass: "fa fa-line-chart",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "label": "Contract",
      "prop": "Contract",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Send welcome email",
            "placement": "bottom"
          }
        }, [_c('button', {
          staticClass: "el-button notes-box el-button--text forcontract",
          staticStyle: {
            "background": "#33ce33",
            "color": "white"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.confirmSendWelcomeEmail(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-envelope",
          attrs: {
            "aria-hidden": "true"
          }
        })])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Create Contract",
            "placement": "bottom"
          }
        }, [_c('router-link', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "background": "#efb71b",
            "color": "white"
          },
          attrs: {
            "to": ("" + ('/admin/publisher/contract/'+ props.row.id))
          }
        }, [_c('i', {
          staticClass: "fa fa-plus",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Upload Signed Contract",
            "placement": "bottom"
          }
        }, [_c('button', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "background": "blue",
            "color": "white"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.dialogVisiblecontract(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])]), _vm._v(" "), (!props.row.contract_details.sign_pdf) ? _c('el-tooltip', {
          attrs: {
            "content": "Contract not uploaded",
            "placement": "bottom"
          }
        }, [_c('label', {
          key: props.row.contract_details.sign_pdf,
          staticClass: "el-button notes-box el-button--text el-button--small bg-success forcontract",
          staticStyle: {
            "cursor": "not-allowed",
            "background": "red",
            "color": "white"
          }
        }, [_c('i', {
          staticClass: "fa fa-ban"
        })])]) : _c('el-tooltip', {
          attrs: {
            "content": "Download Signed Contract",
            "placement": "bottom"
          }
        }, [_c('a', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "background": "#00ced1",
            "color": "white"
          },
          attrs: {
            "href": props.row.contract_details.sign_pdf
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tax Form",
      "prop": "uuid",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Upload Tax form",
            "placement": "bottom"
          }
        }, [_c('button', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "background": "blue",
            "color": "white"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.dialogVisiblef(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])]), _vm._v(" "), (!props.row.contract_details.tax_pdf) ? _c('el-tooltip', {
          attrs: {
            "content": "Tax form not uploaded",
            "placement": "bottom"
          }
        }, [_c('label', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "cursor": "not-allowed",
            "background": "red",
            "color": "white"
          }
        }, [_c('i', {
          staticClass: "fa fa-ban"
        })])]) : _c('el-tooltip', {
          attrs: {
            "content": "Download Tax form",
            "placement": "bottom"
          }
        }, [_c('a', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "background": "#00ced1",
            "color": "white"
          },
          attrs: {
            "href": props.row.contract_details.tax_pdf
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Edit",
      "prop": "publisher",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Edit Publisher",
            "placement": "bottom"
          }
        }, [_c('button', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "background": "white",
            "color": "black"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showEditScreenVisiblefuncton(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Bank Details",
      "prop": "publisher",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Copy Bank Details",
            "placement": "bottom"
          }
        }, [_c('button', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "background": "white",
            "color": "black"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showBankInfoScreenVisiblefuncton(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-bank"
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Account Activate",
      "prop": "publisher",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Send Account Activate to Intentt External Publisher",
            "placement": "bottom"
          }
        }, [_c('button', {
          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
          staticStyle: {
            "background": "white",
            "color": "black"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.confirmIntenttNividEmailSend(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-envelope"
        })])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "report-upload-popup",
    attrs: {
      "visible": _vm.EditScreenVisible,
      "before-close": _vm.closeEditScreen
    },
    on: {
      "update:visible": function($event) {
        _vm.EditScreenVisible = $event
      }
    }
  }, [
    [_c('div', [_c('h3', [_vm._v("Update Publisher")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "10px 0px"
      }
    }, [_c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('name')
      },
      attrs: {
        "data-vv-delay": "1000",
        "name": "name",
        "type": "text",
        "placeholder": "15%"
      },
      model: {
        value: (_vm.editPubForm.name),
        callback: function($$v) {
          _vm.$set(_vm.editPubForm, "name", $$v)
        },
        expression: "editPubForm.name"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('name')),
        expression: "errors.has('name')"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "10px 0px"
      }
    }, [_c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('email')
      },
      attrs: {
        "data-vv-delay": "1000",
        "name": "email",
        "type": "text",
        "placeholder": "15%"
      },
      model: {
        value: (_vm.editPubForm.email),
        callback: function($$v) {
          _vm.$set(_vm.editPubForm, "email", $$v)
        },
        expression: "editPubForm.email"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('email')),
        expression: "errors.has('email')"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "10px 0px"
      }
    }, [_c('span', [_vm._v("enable AMP Setup")]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-color": "#ff4949"
      },
      model: {
        value: (_vm.editPubForm.amp_ss_enable),
        callback: function($$v) {
          _vm.$set(_vm.editPubForm, "amp_ss_enable", $$v)
        },
        expression: "editPubForm.amp_ss_enable"
      }
    })], 1), _vm._v(" "), _c('div', [_c('el-button', {
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.EditPublisher()
        }
      }
    }, [_vm._v("Update Publisher")])], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "report-upload-popup",
    attrs: {
      "visible": _vm.bankInfoScreenVisible,
      "before-close": _vm.closeBankInfoScreen
    },
    on: {
      "update:visible": function($event) {
        _vm.bankInfoScreenVisible = $event
      }
    }
  }, [
    [_c('div', [_c('h3', [_vm._v("Bank Details")])]), _vm._v(" "), _c('pre', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "id": "divClipboard"
      }
    }, [_vm._v(_vm._s(_vm.bankDetail))]), _vm._v(" "), (!_vm.iscopied) ? _c('el-button', {
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.copiedToClipboard()
        }
      }
    }, [_vm._v("Copy to clipboard")]) : _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Copied")])]
  ], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "report-upload-popup",
    attrs: {
      "visible": _vm.UploadScreenVisible,
      "before-close": _vm.clearFilesList
    },
    on: {
      "update:visible": function($event) {
        _vm.UploadScreenVisible = $event
      }
    }
  }, [
    [_c('el-upload', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.uploading),
        expression: "uploading"
      }],
      ref: "file",
      staticClass: "upload-demo m-t-20",
      attrs: {
        "drag": "",
        "limit": 1,
        "action": "v1/upload-tax-docs/",
        "auto-upload": false,
        "http-request": _vm.upload,
        "file-list": _vm.fileList,
        "on-change": _vm.handleFileUpload
      }
    }, [_c('i', {
      staticClass: "el-icon-upload"
    }), _vm._v(" "), _c('div', {
      staticClass: "el-upload__text"
    }, [_vm._v("\n                Drop file here or\n                "), _c('em', [_vm._v("click to upload")])])]), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      on: {
        "click": _vm.cancelUploadAction
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.submitFile()
        }
      }
    }, [_vm._v("Upload Tax Form")])], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "report-upload-popup",
    attrs: {
      "visible": _vm.contractvisiblescreen,
      "before-close": _vm.clearFilesList
    },
    on: {
      "update:visible": function($event) {
        _vm.contractvisiblescreen = $event
      }
    }
  }, [
    [_c('el-upload', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.uploading),
        expression: "uploading"
      }],
      ref: "file",
      staticClass: "upload-demo m-t-20",
      attrs: {
        "drag": "",
        "limit": 1,
        "action": "v1/upload-contract/",
        "auto-upload": false,
        "http-request": _vm.upload,
        "file-list": _vm.fileList,
        "on-change": _vm.handleFileUploadcontract
      }
    }, [_c('i', {
      staticClass: "el-icon-upload"
    }), _vm._v(" "), _c('div', {
      staticClass: "el-upload__text"
    }, [_vm._v("\n                Drop file here or\n                "), _c('em', [_vm._v("click to upload")])])]), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      on: {
        "click": _vm.cancelUploadAction
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.submitcontract()
        }
      }
    }, [_vm._v("Upload Contract")])], 1)]
  ], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "page-size": _vm.offset,
      "pager-count": 20,
      "layout": "prev, pager, next",
      "total": _vm.total_pages,
      "current-page": _vm.currentPage
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('transition', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48f822fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/AllPublisher.vue
// module id = 684
// module chunks = 2